import { ReactNode, useMemo } from "react";
import { SxProps, Theme } from "@mui/material";
import { useTranslation } from "next-i18next";
import { IWikifolioDetailProps } from "src/api/server/wf-detail.types";
import { JumpMarksBar, TJumpMarkTabTrackingAttributes } from "src/components-mui/common/jump-marks/jump-marks-bar";
import { JumpMarksProvider } from "src/components-mui/common/jump-marks/jump-marks-provider";
import { IJumpMarkItem } from "src/components-mui/common/jump-marks/jump-marks.types";
import { useStickyNavHeight } from "src/hooks/use-sticky-nav-height";

export const DetailJumpMark = {
    Overview: "overview",
    Feed: "feed",
    TradingIdea: "tradingidea",
    Portfolio: "portfolio",
    KeyFigures: "keyfigures",
    Trades: "trades",
} as const;
export type DetailJumpMark = (typeof DetailJumpMark)[keyof typeof DetailJumpMark];

type TDetailJumpMarkLabels = IWikifolioDetailProps["dict"]["jumpMarks"];

interface IDetailJumpMarksProviderProps {
    labels: TDetailJumpMarkLabels;
    children: ReactNode;
}

export const DetailJumpMarksProvider = ({ labels, children }: IDetailJumpMarksProviderProps) => {
    const items = useMemo(
        () => Object.values(DetailJumpMark).map(id => ({ id, label: labels[id], isPageTop: id === DetailJumpMark.Overview })),
        [labels]
    );
    const stickyNavHeightPx = useStickyNavHeight();

    return (
        <JumpMarksProvider items={items} stickyNavHeightPx={stickyNavHeightPx}>
            {children}
        </JumpMarksProvider>
    );
};

const getDetailTabTrackingAttributes = ({ id }: IJumpMarkItem): TJumpMarkTabTrackingAttributes => ({
    className: "gtm-jumpmark",
    "data-gtm-action": id,
});

interface IDetailJumpMarksBarProps {
    sx?: SxProps<Theme>;
}

export const DetailJumpMarksBar = ({ sx }: IDetailJumpMarksBarProps) => {
    const { t } = useTranslation("wf-detail");

    return <JumpMarksBar label={t("jump-marks-navigation-label")} getTabTrackingAttributes={getDetailTabTrackingAttributes} sx={sx} />;
};
